/* global lek004_global_data */

export default lek004_global_data.l10n
